export default __webpack_public_path__ + "static/media/oxigenoterapia_neonatologia.d4769456.pdf";